<script setup>
import { useGlobalStore } from '@stores/global.js'
import Footer from '@sections/global/Footer.vue'
import UploadModal from '@components/global/modals/UploadModal.vue'
const global = useGlobalStore()
</script>

<template>
	<!-- Modal -->
	<Transition name="fade">
		<UploadModal v-if="global.modal?.name == 'upload'" :key="global.modal.name" />
	</Transition>

	<router-view v-slot="{ Component, route }">
		<transition name="page" mode="out-in">
			<Component :is="Component" :key="route.path" />
		</transition>
	</router-view>
	<Footer />
</template>
